const state = {
  userData: null,
  menu: []
}

export default state
